module.exports = "/images/ingredients-3.png";